import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { Person, PersonFilter, PersonFilterMeta } from '../../models/person';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-people-filters',
  styleUrls: ['./people-filters.component.scss'],
  templateUrl: './people-filters.component.html',
})
export class PeopleFiltersComponent extends BaseFiltersComponent<Person, FilterFieldsOptions<PersonFilter>> {

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, PersonFilterMeta);
  }

}
